import React from 'react';

import phoneIcon from 'assets/pics/combined-shape.png';
import PropTypes from 'prop-types';

import { EmailIcon } from 'components/Icons/EmailIcon';
import { SubTitle } from 'components/SubTitle/SubTitle';

import { TENANT_ID } from 'global/constants';

import { getTenantId } from 'utils/tenantUtil';

import './ContactResultItem.scss';

export const ContactResultItem = ({
  title,
  marker,
  salesOffice,
  phoneNumberCall,
  phoneNumberDisplay,
  onSendMessageClick,
  email,
}) => {
  const renderSendMessage = () => {
    if (!onSendMessageClick && !email) {
      return null;
    }

    if (onSendMessageClick) {
      return (
        <button type="button" className="email-modal-open" onClick={onSendMessageClick}>
          <EmailIcon />
          <div className="icon-label">Nachricht senden</div>
        </button>
      );
    }

    return (
      <a className="email-modal-open" href={`mailto:${email}`}>
        <EmailIcon />
        <div className="icon-label">Nachricht senden</div>
      </a>
    );
  };

  return (
    <div className="mdl-grid mdl-cell--12-col result-subcontainer">
      <div className="mdl-cell--6-col mdl-cell--12-col-phone result-headline">
        <SubTitle text={title} />
        {marker && (
          <div className="expert-search-results__marker-text">
            *Der Ort wird von zwei Kundencentren betreut, ggf. werden Sie weitergeleitet
          </div>
        )}
      </div>
      <div className="mdl-cell--6-col mdl-cell--12-col-phone result-number">
        {getTenantId() === TENANT_ID.BAG && salesOffice && (
          <div className="expert-search-results__sales-office-text">{salesOffice}</div>
        )}
        {phoneNumberDisplay && (
          <>
            <h6>
              <img alt="" src={phoneIcon} />
              <a href={`tel:${phoneNumberCall}`}>{phoneNumberDisplay}</a>
            </h6>
            <span className="notice">Während der üblichen Geschäftszeiten</span>
          </>
        )}
        {renderSendMessage()}
      </div>
    </div>
  );
};

ContactResultItem.propTypes = {
  title: PropTypes.string.isRequired,
  marker: PropTypes.bool,
  salesOffice: PropTypes.string,
  phoneNumberCall: PropTypes.string,
  phoneNumberDisplay: PropTypes.string,
  onSendMessageClick: PropTypes.func,
  email: PropTypes.string,
};

ContactResultItem.defaultProps = {
  marker: false,
  salesOffice: null,
  phoneNumberCall: null,
  phoneNumberDisplay: null,
  onSendMessageClick: null,
  email: null,
};
